/**
 * Onglet Test des intégrations
 * @module admin/tabs/IntegrationsTab
 */

import React, { useEffect, useState } from 'react';
import { useIntegrations } from '../hooks/useIntegrations';
import AdminResult from '../components/AdminResult';

const DEFAULT_TEST_EMAIL = 'contactdesigne@gmail.com';

const IntegrationsTab = () => {
  const {
    integrationStatus,
    maintenanceLoading,
    maintenanceResult,
    maintenanceError,
    fetchIntegrationStatus,
    handleTestIntegration,
    handleTestMail,
  } = useIntegrations();
  const [testMailEmail, setTestMailEmail] = useState(DEFAULT_TEST_EMAIL);

  useEffect(() => {
    fetchIntegrationStatus();
  }, [fetchIntegrationStatus]);

  const renderIntegrationCard = (service, status) => (
    <div key={service} className="admin-integration-card">
      <h3>{service === 'twitch' ? 'Twitch' : 'Spotify'}</h3>
      <div
        className={`admin-status-indicator ${
          status?.connected ? 'connected' : 'disconnected'
        }`}
      >
        {status?.connected ? '✓ Connecté' : '✗ Déconnecté'}
      </div>
      <div className="admin-integration-details">
        <p>
          <strong>Tokens présents:</strong>{' '}
          {status?.details?.hasTokens ? 'Oui' : 'Non'}
        </p>
        <p>
          <strong>Token expiré:</strong>{' '}
          {status?.details?.isExpired ? 'Oui' : 'Non'}
        </p>
        {status?.details?.error && (
          <p className="admin-error">
            <strong>Erreur:</strong> {status.details.error}
          </p>
        )}
      </div>
      <button
        className="admin-button admin-button-primary"
        onClick={() => handleTestIntegration(service)}
        disabled={maintenanceLoading}
      >
        {maintenanceLoading
          ? 'Test en cours...'
          : `Tester la connexion ${
              service === 'twitch' ? 'Twitch' : 'Spotify'
            }`}
      </button>
    </div>
  );

  const renderMailCard = () => {
    const status = integrationStatus?.mail;
    return (
      <div className="admin-integration-card">
        <h3>Mail (SMTP)</h3>
        <div
          className={`admin-status-indicator ${
            status?.connected ? 'connected' : 'disconnected'
          }`}
        >
          {status?.connected ? '✓ Connecté' : '✗ Déconnecté'}
        </div>
        <div className="admin-integration-details">
          <p>
            <strong>Service:</strong>{' '}
            {status?.details?.enabled ? 'Activé' : 'Désactivé'}
          </p>
          {status?.details?.host && (
            <p>
              <strong>Serveur:</strong> {status.details.host}:{status.details.port}
            </p>
          )}
          {status?.details?.message && (
            <p>
              <strong>Statut:</strong> {status.details.message}
            </p>
          )}
          {status?.details?.error && (
            <p className="admin-error">
              <strong>Erreur:</strong> {status.details.error}
            </p>
          )}
        </div>
        <div className="admin-field admin-mail-test">
          <label htmlFor="test-mail-email">
            Envoyer un email de test à :
          </label>
          <div className="admin-mail-test-row">
            <input
              id="test-mail-email"
              type="email"
              value={testMailEmail}
              onChange={(e) => setTestMailEmail(e.target.value)}
              placeholder="email@exemple.com"
              disabled={maintenanceLoading}
            />
            <button
              className="admin-button admin-button-primary"
              onClick={() => handleTestMail(testMailEmail)}
              disabled={maintenanceLoading}
            >
              {maintenanceLoading ? 'Test en cours...' : 'Tester et envoyer'}
            </button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <section className="admin-section">
      <h2>🔌 Test des intégrations</h2>

      {integrationStatus ? (
        <div className="admin-integration-status">
          {renderIntegrationCard('twitch', integrationStatus.twitch)}
          {renderIntegrationCard('spotify', integrationStatus.spotify)}
          {renderMailCard()}
        </div>
      ) : (
        <p className="admin-loading">
          Chargement du statut des intégrations...
        </p>
      )}

      <button
        className="admin-button admin-button-secondary"
        onClick={fetchIntegrationStatus}
      >
        Actualiser le statut
      </button>

      {maintenanceResult && (
        <AdminResult isSuccess={true} title="Résultat du test">
          <p>
            <strong>Message:</strong> {maintenanceResult.message}
          </p>
          {maintenanceResult.data?.sentTo && (
            <p>
              <strong>Email envoyé à :</strong> {maintenanceResult.data.sentTo}
            </p>
          )}
          {maintenanceResult.data && (
            <div className="admin-test-results">
              <strong>Informations récupérées:</strong>
              <pre>{JSON.stringify(maintenanceResult.data, null, 2)}</pre>
            </div>
          )}
        </AdminResult>
      )}

      {maintenanceError && (
        <AdminResult
          isSuccess={false}
          title="Erreur du test"
          message={maintenanceError}
        />
      )}
    </section>
  );
};

export default IntegrationsTab;
